import { START_BOOKINGS_LOADING } from "./types";

const toggleBookingsLoading = () => ({
  type: START_BOOKINGS_LOADING,
});

export default toggleBookingsLoading;
